import * as types from '../constants/actionTypes'

const isLoading = (state = false, action) => {
  switch (action.type) {
    case types.SetLoading:
      return action.isLoading
    default:
      return state
  }
}

export default isLoading
